import React, { useState } from 'react';
// Framer Motion supprimé - utilisation d'animations CSS
import {
  Play,
  Pause,
  Clock,
  Users,
  Star,
  BookOpen,
  Search,
  PlayCircle,
  CheckCircle,
  ChevronDown,
  ChevronUp,
  Calendar
} from 'lucide-react';

const ELearning = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('Tous');
  const [selectedLevel, setSelectedLevel] = useState('Tous');
  const [expandedVideo, setExpandedVideo] = useState(null);
  const [playingVideo, setPlayingVideo] = useState(null);

  const categories = ['Tous', 'Cardiologie', 'Pédiatrie', 'Neurologie', 'Chirurgie', 'Médecine générale', 'Urgences'];
  const levels = ['Tous', 'Débutant', 'Intermédiaire', 'Avancé', 'Expert'];

  const mockVideos = [
    {
      id: 1,
      title: 'Introduction à la cardiologie tropicale',
      instructor: 'Dr. Jean Mukamba',
      category: 'Cardiologie',
      level: 'Débutant',
      description: 'Cours complet sur les maladies cardiovasculaires en milieu tropical, incluant le diagnostic et le traitement des pathologies courantes.',
      duration: '45 min',
      views: 1250,
      rating: 4.8,
      thumbnail: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=225&fit=crop',
      videoUrl: '#',
      isCompleted: false,
      progress: 0,
      uploadDate: '2024-01-10',
      tags: ['cardiologie', 'tropical', 'diagnostic'],
      chapters: [
        { title: 'Introduction', duration: '5 min', isCompleted: false },
        { title: 'Anatomie du cœur', duration: '10 min', isCompleted: false },
        { title: 'Pathologies courantes', duration: '15 min', isCompleted: false },
        { title: 'Diagnostic différentiel', duration: '10 min', isCompleted: false },
        { title: 'Traitements', duration: '5 min', isCompleted: false }
      ]
    },
    {
      id: 2,
      title: 'Protocoles de vaccination pédiatrique',
      instructor: 'Dr. Marie Kabongo',
      category: 'Pédiatrie',
      level: 'Intermédiaire',
      description: 'Guide pratique pour la mise en place de programmes de vaccination efficaces en milieu rural et urbain.',
      duration: '38 min',
      views: 890,
      rating: 4.9,
      thumbnail: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=400&h=225&fit=crop',
      videoUrl: '#',
      isCompleted: true,
      progress: 100,
      uploadDate: '2024-01-08',
      tags: ['vaccination', 'pédiatrie', 'prévention'],
      chapters: [
        { title: 'Calendrier vaccinal', duration: '8 min', isCompleted: true },
        { title: 'Techniques d\'injection', duration: '12 min', isCompleted: true },
        { title: 'Gestion des effets secondaires', duration: '10 min', isCompleted: true },
        { title: 'Cas particuliers', duration: '8 min', isCompleted: true }
      ]
    },
    {
      id: 3,
      title: 'Chirurgie d\'urgence en conditions limitées',
      instructor: 'Dr. Sarah Mwamba',
      category: 'Chirurgie',
      level: 'Avancé',
      description: 'Techniques chirurgicales adaptées aux environnements avec ressources limitées et équipements de base.',
      duration: '52 min',
      views: 756,
      rating: 4.7,
      thumbnail: 'https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=400&h=225&fit=crop',
      videoUrl: '#',
      isCompleted: false,
      progress: 35,
      uploadDate: '2024-01-05',
      tags: ['chirurgie', 'urgence', 'techniques'],
      chapters: [
        { title: 'Préparation du patient', duration: '8 min', isCompleted: true },
        { title: 'Anesthésie locale', duration: '12 min', isCompleted: true },
        { title: 'Techniques de base', duration: '15 min', isCompleted: false },
        { title: 'Gestion des complications', duration: '10 min', isCompleted: false },
        { title: 'Post-opératoire', duration: '7 min', isCompleted: false }
      ]
    },
    {
      id: 4,
      title: 'Diagnostic neurologique en première ligne',
      instructor: 'Dr. Pierre Mbuyi',
      category: 'Neurologie',
      level: 'Intermédiaire',
      description: 'Approche systématique du diagnostic des troubles neurologiques avec les moyens disponibles en première ligne.',
      duration: '41 min',
      views: 634,
      rating: 4.6,
      thumbnail: 'https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=400&h=225&fit=crop',
      videoUrl: '#',
      isCompleted: false,
      progress: 0,
      uploadDate: '2024-01-03',
      tags: ['neurologie', 'diagnostic', 'examen clinique'],
      chapters: [
        { title: 'Examen neurologique', duration: '12 min', isCompleted: false },
        { title: 'Signes d\'alerte', duration: '8 min', isCompleted: false },
        { title: 'Pathologies courantes', duration: '15 min', isCompleted: false },
        { title: 'Orientation du patient', duration: '6 min', isCompleted: false }
      ]
    },
    {
      id: 5,
      title: 'Gestion des urgences médicales',
      instructor: 'Dr. Grace Tshisekedi',
      category: 'Urgences',
      level: 'Débutant',
      description: 'Protocoles de prise en charge des urgences médicales les plus fréquentes en milieu hospitalier.',
      duration: '33 min',
      views: 1120,
      rating: 4.8,
      thumbnail: 'https://images.unsplash.com/photo-1576091160550-2173dba0ef08?w=400&h=225&fit=crop',
      videoUrl: '#',
      isCompleted: false,
      progress: 60,
      uploadDate: '2024-01-01',
      tags: ['urgences', 'protocoles', 'réanimation'],
      chapters: [
        { title: 'Évaluation initiale', duration: '8 min', isCompleted: true },
        { title: 'Réanimation cardio-pulmonaire', duration: '12 min', isCompleted: true },
        { title: 'Choc et collapsus', duration: '8 min', isCompleted: false },
        { title: 'Troubles respiratoires', duration: '5 min', isCompleted: false }
      ]
    },
    {
      id: 6,
      title: 'Nutrition thérapeutique en médecine générale',
      instructor: 'Dr. Joseph Kabila',
      category: 'Médecine générale',
      level: 'Débutant',
      description: 'Intégration de la nutrition dans la prise en charge des patients chroniques et aigus.',
      duration: '29 min',
      views: 445,
      rating: 4.5,
      thumbnail: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400&h=225&fit=crop',
      videoUrl: '#',
      isCompleted: false,
      progress: 0,
      uploadDate: '2023-12-28',
      tags: ['nutrition', 'thérapeutique', 'chronique'],
      chapters: [
        { title: 'Besoins nutritionnels', duration: '6 min', isCompleted: false },
        { title: 'Pathologies chroniques', duration: '10 min', isCompleted: false },
        { title: 'Supplémentation', duration: '8 min', isCompleted: false },
        { title: 'Suivi et évaluation', duration: '5 min', isCompleted: false }
      ]
    }
  ];

  const filteredVideos = mockVideos.filter(video => {
    const matchesSearch = video.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         video.instructor.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         video.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    const matchesCategory = selectedCategory === 'Tous' || video.category === selectedCategory;
    const matchesLevel = selectedLevel === 'Tous' || video.level === selectedLevel;
    return matchesSearch && matchesCategory && matchesLevel;
  });

  const handlePlay = (videoId) => {
    setPlayingVideo(playingVideo === videoId ? null : videoId);
  };

  const toggleExpanded = (videoId) => {
    setExpandedVideo(expandedVideo === videoId ? null : videoId);
  };

  const getLevelColor = (level) => {
    switch (level) {
      case 'Débutant': return 'bg-green-100 text-green-800';
      case 'Intermédiaire': return 'bg-yellow-100 text-yellow-800';
      case 'Avancé': return 'bg-orange-100 text-orange-800';
      case 'Expert': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div
            
            
            className="flex items-center space-x-3 mb-4"
          >
            <div className="p-3 bg-purple-100 rounded-lg">
              <PlayCircle className="h-8 w-8 text-purple-600" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-900">E-Learning Médical</h1>
              <p className="text-gray-600">Formation continue pour les professionnels de santé</p>
            </div>
          </div>

          {/* Search and Filters */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex flex-col lg:flex-row gap-4">
              {/* Search */}
              <div className="flex-1">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Rechercher des cours..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  />
                </div>
              </div>

              {/* Category Filter */}
              <div className="lg:w-48">
                <select
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                >
                  {categories.map(category => (
                    <option key={category} value={category}>{category}</option>
                  ))}
                </select>
              </div>

              {/* Level Filter */}
              <div className="lg:w-48">
                <select
                  value={selectedLevel}
                  onChange={(e) => setSelectedLevel(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                >
                  {levels.map(level => (
                    <option key={level} value={level}>{level}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Video Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredVideos.map((video, index) => (
            <div
              key={video.id}
              className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition-shadow duration-200"
            >
              {/* Video Thumbnail */}
              <div className="relative h-48 bg-gradient-to-br from-purple-50 to-purple-100">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
                  <button
                    onClick={() => handlePlay(video.id)}
                    className="bg-white bg-opacity-90 rounded-full p-4 hover:bg-opacity-100 transition-all duration-200"
                  >
                    {playingVideo === video.id ? (
                      <Pause className="h-8 w-8 text-purple-600" />
                    ) : (
                      <Play className="h-8 w-8 text-purple-600 ml-1" />
                    )}
                  </button>
                </div>
                <div className="absolute top-4 right-4 bg-black bg-opacity-75 text-white px-2 py-1 rounded text-sm">
                  {video.duration}
                </div>
                <div className="absolute bottom-4 left-4 bg-black bg-opacity-75 text-white px-2 py-1 rounded text-sm flex items-center">
                  <Users className="h-4 w-4 mr-1" />
                  {video.views}
                </div>
                {video.isCompleted && (
                  <div className="absolute top-4 left-4 bg-green-500 text-white rounded-full p-2">
                    <CheckCircle className="h-5 w-5" />
                  </div>
                )}
              </div>

              {/* Video Content */}
              <div className="p-6">
                <div className="flex items-start justify-between mb-3">
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-gray-900 mb-1 line-clamp-2">
                      {video.title}
                    </h3>
                    <p className="text-sm text-gray-600 mb-2">Par {video.instructor}</p>
                  </div>
                  <div className="flex items-center space-x-1 ml-2">
                    <Star className="h-4 w-4 text-yellow-400 fill-current" />
                    <span className="text-sm text-gray-600">{video.rating}</span>
                  </div>
                </div>

                <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                  {video.description}
                </p>

                {/* Category and Level */}
                <div className="mb-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <span className="inline-block bg-purple-100 text-purple-800 text-xs px-2 py-1 rounded-full">
                      {video.category}
                    </span>
                    <span className={`inline-block text-xs px-2 py-1 rounded-full ${getLevelColor(video.level)}`}>
                      {video.level}
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-1">
                    {video.tags.slice(0, 2).map(tag => (
                      <span key={tag} className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                        #{tag}
                      </span>
                    ))}
                    {video.tags.length > 2 && (
                      <span className="text-xs text-gray-500">+{video.tags.length - 2}</span>
                    )}
                  </div>
                </div>

                {/* Progress Bar */}
                {video.progress > 0 && (
                  <div className="mb-4">
                    <div className="flex items-center justify-between text-sm text-gray-600 mb-1">
                      <span>Progression</span>
                      <span>{video.progress}%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div 
                        className="bg-purple-600 h-2 rounded-full transition-all duration-300"
                        style={{ width: `${video.progress}%` }}
                      ></div>
                    </div>
                  </div>
                )}

                {/* Stats */}
                <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                  <div className="flex items-center space-x-4">
                    <span className="flex items-center">
                      <Calendar className="h-4 w-4 mr-1" />
                      {new Date(video.uploadDate).toLocaleDateString('fr-FR')}
                    </span>
                    <span className="flex items-center">
                      <Clock className="h-4 w-4 mr-1" />
                      {video.duration}
                    </span>
                  </div>
                </div>

                {/* Actions */}
                <div className="flex space-x-2">
                  <button
                    onClick={() => handlePlay(video.id)}
                    className="flex-1 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors duration-200 flex items-center justify-center"
                  >
                    <Play className="h-4 w-4 mr-2" />
                    {video.progress > 0 ? 'Continuer' : 'Commencer'}
                  </button>
                  <button
                    onClick={() => toggleExpanded(video.id)}
                    className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors duration-200 flex items-center justify-center"
                  >
                    <BookOpen className="h-4 w-4 mr-2" />
                    {expandedVideo === video.id ? 'Moins' : 'Chapitres'}
                    {expandedVideo === video.id ? <ChevronUp className="h-4 w-4 ml-1" /> : <ChevronDown className="h-4 w-4 ml-1" />}
                  </button>
                </div>

                {/* Expanded Chapters */}
                {expandedVideo === video.id && (
                  <div className="mt-4 pt-4 border-t border-gray-200">
                    <h4 className="text-sm font-medium text-gray-900 mb-3">Chapitres du cours</h4>
                    <div className="space-y-2">
                      {video.chapters.map((chapter, index) => (
                        <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
                          <div className="flex items-center space-x-3">
                            {chapter.isCompleted ? (
                              <CheckCircle className="h-5 w-5 text-green-500" />
                            ) : (
                              <div className="h-5 w-5 border-2 border-gray-300 rounded-full"></div>
                            )}
                            <span className="text-sm text-gray-900">{chapter.title}</span>
                          </div>
                          <span className="text-xs text-gray-500">{chapter.duration}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Empty State */}
        {filteredVideos.length === 0 && (
          <div className="text-center py-12">
            <PlayCircle className="h-16 w-16 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">Aucun cours trouvé</h3>
            <p className="text-gray-600">Essayez de modifier vos critères de recherche</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ELearning;